import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  mediaRecorderRef,
} from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { uploadUserDocument } from "api/formDisplay";
import { livenessDetection } from "api/formDisplay";
import "./index.scss";
import leftImage from "../../assets/images/f-left.png";
import rightImage from "../../assets/images/f-right.png";
import upImage from "../../assets/images/f-up.png";
import downImage from "../../assets/images/f-down.png";
import Webcam from "react-webcam";
import { setUploadLoading } from "redux/configurationReducer";
import { setVerificationResponse } from "redux/uploadDocumentReducer";

const LivenessCheck = (props) => {
  const {
    name,
    setUploaded,
    setFileName,
    setFileSize,
    setSelectedData,
    label,
    userInfo,
    clearFieldError,
    user_action,
    doc_type,
    random_generate
  } = props;
   
  let picture, res, direction, response,pictureName,pictureSrc,dir,userAction;
  const [errorMsg, setErrorMsg] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const [now, setNow] = useState(0);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  // const [uploaded, setUploaded] = useState(false);
  const videoRef = useRef(null);
  // const handleClose = () => setShow(false);
  const [start, setStart] = useState(true);
  const [restart, setRestart] = useState(false);
  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [capturing, setCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);
  const [recording, setRecording] = useState(false);
 
 
  const [intervalId, setIntervalId] = useState(false);
  const [timeoutId, setTimeoutId] = useState(false);
  // const [videoDuration, setVideoDuration] = useState(null);
  const organisationId = useSelector(
    (state) => state.configurationReducer.config?.organisation_id
    );
    const [randomAction] = useState(getRandomAction());
    const sub_id = useSelector((state) => state.urlEncryption?.urlId?.subWfId);
    const primary_workflow_id = useSelector((state) => state.urlEncryption?.urlId?.primary_workflow_id);
  const docType = doc_type?.toLowerCase() || "document";
 
  const handleShow = () => {
    if(!setRestart) setStart(true)
    setShow(true)
  }
 
  const handleClose = () => {
    setShow(false)
    clearInterval(intervalId);
    clearTimeout(timeoutId);
    setRecording(false);
    setNow(0)
    setStart(true)
    setRestart(false)
    setErrorMsg(false)
  }

  function getImageName(userAction) {
    if (userAction.is_default === true) {
      response = {
        res: userAction.type,
        direction: userAction.name,
      };
      return response;
    }
    
  }
  const matchingAction = user_action.find(
    (action) => action.is_default === true
  );

  pictureName = matchingAction ? getImageName(matchingAction) : randomAction;
  //   const pictureSrc = `../../assets/images/${pictureName}.png`;
  function getRandomAction() {
    const actions = ["f-left", "f-right", "f-up", "f-down"];
    const randomIndex = Math.floor(Math.random() * actions.length);
    return actions[randomIndex];
  }
  
   pictureSrc = (() => {
    switch (pictureName?.res || pictureName) {
      case "f-left":
        return leftImage;
      case "f-right":
        return rightImage;
      case "f-up":
        return upImage;
      case "f-down":
        return downImage;
      default:
        return "";
    }
  })();
  const foundAction = user_action.find(action => action.type === pictureName);
  if (foundAction) {
    dir = foundAction?.name;
  }
 direction = response?.direction || dir
 userAction = pictureName?.res || pictureName

  let videoConstraints = {
    width: 300,
    height: 230,
    facingMode: "user",
  };

  const handleStartCaptureClick = React.useCallback(() => {
    setCapturing(true);
    setErrorMsg(false);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: "video/webm",
    });
    // mediaRecorder = new MediaRecorder(stream, options);
    mediaRecorderRef.current.addEventListener(
      "dataavailable",
      handleDataAvailable
    );
    mediaRecorderRef.current.start();
    setRecording(true);
  }, [webcamRef, setCapturing, mediaRecorderRef]);

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  const handleStopCaptureClick = React.useCallback(() => {
    mediaRecorderRef.current.stop();
    setCapturing(false);
    setRestart(false);
    setRecording(false);
    setStart(false);
      const intervalId = setInterval(() => {
        if (now < 100) {
          setNow((now)=>now+4);
        }
      }, 100);
      setIntervalId(intervalId);
  }, [mediaRecorderRef, webcamRef, setCapturing]);

  useEffect(() => {
    if (now >= 100) {
      saveVideo()
      clearTimeout(intervalId)
    }
  },[now])

  const saveVideo = () => {
    if (recordedChunks.length) {
      let base64String;
      const blob = new Blob(recordedChunks, {
        type: "video/webm",
      });
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        base64String = reader.result;
        const file = dataURLtoFile(base64String, "vedio.webm");
        let acceptedFile = [];
        let fileData = {
          file: file,
          file_path: file.name,
          file_size: file.size,
        };
        acceptedFile.push(fileData);
        setFileName(fileData.file_path);
        setFileSize(fileData.file_size);
        clearFieldError && clearFieldError(name);
        // dispatch(uploadUserDocument({ acceptedFile, name, userInfo, userInfo, label, setSelectedData }))
        // setShow(false)
        setIsUploading(true);
        // setUploaded(true)
        let res = await livenessCheck(acceptedFile);
       
      };
    }
  }

  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const livenessCheck = async (acceptedFile) => {
    let result;
    result = await livenessDetection({
      organisationId,
      sub_id,
      acceptedFile,
      userAction,
      name,
      direction,
      primary_workflow_id

    });
    if (result?.status == "success") {
      setShow(false);
      setIsUploading(false);
      // dispatch(setUploadLoading(false));
      dispatch(uploadUserDocument({ acceptedFile, name, userInfo, label, setSelectedData, docType }))
      setUploaded(true);
      // handleClose();
      dispatch(
        setVerificationResponse({
          key: name,
          value: result || result?.data,
        })
      );
     
    } else if (result?.status == "failed") {
      setNow(0);
      setRestart(true);
      setStart(false)
      setUploaded(false);
      dispatch(setUploadLoading(false));
      const errorMessage = result?.message;
      setErrorMsg(true);
     
    }
  };

  useEffect(() => {
    if (recording) {
      const timeoutId = setTimeout(() => {
        handleStopCaptureClick();
      }, 4000);
      setTimeoutId(timeoutId)
    }
  }, [recording]);


  return (
    <>
      <div className="capture_container">
        <div className={props?.className} onClick={handleShow}>
          Record Vedio
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="modal-max-height-unset"
        centered
        size="xl"
        backdrop="static"
        id="capture-modal"
      >
        <Modal.Header>
          <Modal.Title className="d-flex align-items-center">
            <div className="btn border-0 me-2" onClick={handleClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                fill="currentColor"
                class="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
            </div>
            <p className="fs-20px fw-bold m-0 pt-1">Capture liveness</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Row className="justify-content-center">
            <Col xs={12} md={12} lg={9}>
              <div>
                {recording && (
                  <p className="fs-15px fw-bold m-0">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-dot text-danger"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                      </svg>
                    </span>
                    Video recording is in progress.
                  </p>
                )}
                <div className="w-100 bg-primary-green d-flex align-items-center justify-content-center position-relative">
                  <div className="text-center py-4 py-md-5 mt-5 mt-lg-0">
                    <img src={pictureSrc} alt="" className="w-50" />
                    <p className="fs-14px m-0 fw-bold">{direction}</p>
                  </div>

                  <div className="position-absolute top-0 end-0 text-end mt-2 me-2">
                    <Webcam
                      className="w-50 bg-dark webcam-mirror"
                      audio={false}
                      ref={webcamRef}
                      videoConstraints={videoConstraints}
                    />
                  </div>
                </div>
                <div className="position-relative">
                  <ProgressBar
                    className="bg-dark rounded-1 h-35px text-white border-top border-2 border-white"
                    variant="secondary"
                    now={now}
                  />
                  {now > 0 ? (
                    <p className="m-0 fs-13px text-white fw-bold position-absolute top-50 start-50 translate-middle">
                      Analysing...{now}%
                    </p>
                  ) : (
                    <p className="fs-13px text-white fw-bold position-absolute top-50 start-0 ms-3 translate-middle-y lh-1 mx-2 ms-md-3 mx-md-0">
                    Position your face inside the square and look into the camera for capturing a live image. Then, perform the action.
                    </p>
                  )}
                </div>
                {errorMsg && (
                  <div className="bg-danger-light rounded-1 h-35px text-white border-top border-2 border-white d-flex align-items-center">
                    <p className="m-0 fs-12px text-danger d-flex align-items-center lh-1 mx-2 mx-md-0 ms-md-3">
                      <span className="me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Group_22752"
                          data-name="Group 22752"
                          width="21.865"
                          height="21.865"
                          viewBox="0 0 21.865 21.865"
                        >
                          <circle
                            id="Ellipse_331"
                            data-name="Ellipse 331"
                            cx="10.933"
                            cy="10.933"
                            r="10.933"
                            transform="translate(0)"
                            fill="#ffcdcd"
                          />
                          <circle
                            id="Ellipse_330"
                            data-name="Ellipse 330"
                            cx="6.997"
                            cy="6.997"
                            r="6.997"
                            transform="translate(3.859 4.041)"
                            fill="#fe5b5b"
                          />
                          <g
                            id="Group_22783"
                            data-name="Group 22783"
                            transform="translate(9.981 7.102)"
                          >
                            <g
                              id="Rectangle_17086"
                              data-name="Rectangle 17086"
                              transform="translate(0 0)"
                              fill="#fff"
                              stroke="#fff"
                              stroke-width="1"
                            >
                              <rect
                                width="1.749"
                                height="5.685"
                                rx="0.875"
                                stroke="none"
                              />
                              <rect
                                x="0.5"
                                y="0.5"
                                width="0.749"
                                height="4.685"
                                rx="0.375"
                                fill="none"
                              />
                            </g>
                            <g
                              id="Ellipse_333"
                              data-name="Ellipse 333"
                              transform="translate(0 6.56)"
                              fill="#fff"
                              stroke="#fff"
                              stroke-width="1"
                            >
                              <circle
                                cx="0.875"
                                cy="0.875"
                                r="0.875"
                                stroke="none"
                              />
                              <circle
                                cx="0.875"
                                cy="0.875"
                                r="0.375"
                                fill="none"
                              />
                            </g>
                          </g>
                        </svg>
                      </span>
                      Liveness detection failed, please try again when you hear
                      a beep
                    </p>
                  </div>
                )}
                {start && (
                  <div className="text-center mt-3 mt-md-4">
                    <button
                      className="btn bg-primary-dark fs-14px fw-bold text-white rounded-2"
                      onClick={handleStartCaptureClick}
                    >
                      {" "}
                      Start
                    </button>
                  </div>
                )}
                {restart && (
                  <div className="text-center mt-3 mt-md-4">
                    <button
                      className="btn bg-primary-dark fs-14px fw-bold text-white rounded-2"
                      onClick={handleStartCaptureClick}
                    >
                      Re-start
                    </button>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LivenessCheck;
